import { ShieldCheck } from 'lucide-react';
import { PhaseStubPage } from '@/components/layout/PhaseStubPage';

export function QualityPage() {
  return (
    <PhaseStubPage
      title="Quality control"
      phase={3}
      modules={[
        'Configurable check templates per item or stage',
        'Mobile inspection forms with photo upload',
        'Lot hold/release workflow',
        'Linked NCR → CAPA escalation',
      ]}
      icon={ShieldCheck}
    />
  );
}
